import React, { useContext, useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import "./index.css";
import { AppContext } from "../../../contexts/AppContext";
import { ChatAtendenteContext } from "../../../contexts/ChatAtendenteContext";
import { CentralAjudaService } from "../../../services/CentralAjudaService";
import { AtendimentoPayloadType } from "../../../types/AtendimentoPayloadType";

export function CriarAtendimentoForm(){
  const {userData} = useContext(AppContext);
  const {tiposAtendimento, setTiposAtendimento, setAtendimentoAtivo, handleModoVisualizacao} = useContext(ChatAtendenteContext);
  const [tipoAtendimentoSelecionado, setTiposAtendimentoSelecionado] = useState<number>();
  const [showError, setShowError] = useState("");
  const [loadingCriacao, setLoadingCriacao] = useState(false);
  const [loadingTipos, setLoadingTipos] = useState(true);

  useEffect(()=>{
    if(!tiposAtendimento.length){
      setLoadingTipos(true);
      CentralAjudaService.atendimento.getTiposAtendimentos().then((response)=>{
        setTiposAtendimento(response.data);
        setLoadingTipos(false);
      }).catch((error)=>{
        setLoadingTipos(false);
      })
    }
  },[])

  const handleCriarAtendimento = ()=>{
    if(!tipoAtendimentoSelecionado){
      setShowError("Selecione um tipo de atendimento")
      return;
    }

    setLoadingCriacao(true);
    const payload:AtendimentoPayloadType = {
      id_tipo_atendimento: Number(tipoAtendimentoSelecionado),
    };

    CentralAjudaService.atendimento.criarAtendimento(payload, 'central_ajuda').then((response)=>{
      setAtendimentoAtivo(response.data);
      handleModoVisualizacao('chat');
    }).catch((error)=>{
      setLoadingCriacao(false);
        setShowError("Houve um erro ao tentar abrir o atendimento. Por favor tente mais tarde!");
    })
  }

  return(
    <div className="criacao-atendimento-section">
      <div className="body-criacao">
        {!loadingCriacao ? 
          <>
            <div className="label-criacao"><span className="nome">{userData?.nome}</span>, antes de começar escolha um tipo de atendimento</div>
            <div className="tipos-atendimentos-section">
              { tiposAtendimento.length ? 
                  tiposAtendimento.map((item, index)=>{
                    return (
                      <div key={index} className={`atendimento-item ${tipoAtendimentoSelecionado === item.id ? "selecionado" : ""}`} 
                        onClick={()=>{
                          setTiposAtendimentoSelecionado(item?.id)
                          setShowError("")
                        }}
                      >
                        {item.descricao}
                      </div>
                    )
                  })
                : 
                loadingTipos ? 
                  <Alert>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    /> 
                    {"  Buscando opções de atendimentos!"}
                  </Alert> 
                  : 
                  <Alert variant="warning">Não foi possível encontrar nenhum tipo de atendimento disponível</Alert>
              }
            </div>
            {showError && 
              <Alert variant="danger" className="pt-1 pb-1">{showError}</Alert>
            }
          </>
          : 
          <div className="loading-criacao-section">
            <span>Criando atendimento,</span>
            <span>Por favor aguarde</span>
            <Spinner
              as="span"
              animation="border"
              role="status"
              aria-hidden="true"
            />
          </div>
        }
      </div>
      {!loadingCriacao && 
        <button 
          onClick={()=>{
            handleCriarAtendimento()
          }}  
          className="btn btn-criar-atendimento" 
          disabled={!tipoAtendimentoSelecionado}
        >
          Começar Atendimento 
        </button>
      }
    </div>
  )
} 
